/* import __COLOCATED_TEMPLATE__ from './resistor-tempco-error.hbs'; */
import Component from '@glimmer/component';

export default class ResistorTempcoError extends Component {
  // r1 = false;
  // r2 = false;
  // inverting = false;

  get noninverting() {
    return !this.args.inverting;
  }

  get r1Noninverting() {
    return this.args.r1 && !this.args.inverting;
  }
  get r2Noninverting() {
    return this.args.r2 && !this.args.inverting;
  }
  get r1Inverting() {
    return this.args.r1 && this.args.inverting;
  }
  get r2Inverting() {
    return this.args.r2 && this.args.inverting;
  }
}
